const getTimelineGaps = (timelines) => {
  const timelineGaps = [];
  if (timelines == null) {
    return timelines;
  }
  if (timelines.length === 0) {
    return timelineGaps;
  }
  for (let i = 0; i < timelines.length; i += 1) {
    const d1 = new Date(new Date(timelines[i].endTime).getTime() + 1);
    const d2 = i < timelines.length - 1 ? new Date(new Date(timelines[i + 1].startTime).getTime() - 1) : null;
    if (d2 == null) {
      break;
    }
    timelineGaps.push({ start: d1, end: d2 });
  }
  console.log('timelineGaps: ', timelineGaps);
  return timelineGaps;
};

export default getTimelineGaps;
